!function (t, e) {
  if ("object" === typeof exports && "object" === typeof module) module.exports = e(require("react"));else if ("function" === typeof define && define.amd) define(["react"], e);else {
    var n = e("object" === typeof exports ? require("react") : t.react);

    for (var r in n) {
      ("object" === typeof exports ? exports : t)[r] = n[r];
    }
  }
}(this, function (t) {
  return function (t) {
    function e(r) {
      if (n[r]) return n[r].exports;
      var o = n[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return t[r].call(o.exports, o, o.exports, e), o.l = !0, o.exports;
    }

    var n = {};
    return e.m = t, e.c = n, e.d = function (t, n, r) {
      e.o(t, n) || Object.defineProperty(t, n, {
        configurable: !1,
        enumerable: !0,
        get: r
      });
    }, e.n = function (t) {
      var n = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return e.d(n, "a", n), n;
    }, e.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, e.p = "", e(e.s = 0);
  }([function (t, e, n) {
    t.exports = n(1);
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = n(2);
    e.default = r.a;
  }, function (t, e, n) {
    "use strict";

    function r(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function o(t, e) {
      if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !e || "object" !== typeof e && "function" !== typeof e ? t : e;
    }

    function a(t, e) {
      if ("function" !== typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }

    var i = n(3),
        u = n.n(i),
        c = n(4),
        f = n.n(c),
        s = n(9),
        l = n.n(s),
        p = function () {
      function t(t, e) {
        for (var n = 0; n < e.length; n++) {
          var r = e[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
        }
      }

      return function (e, n, r) {
        return n && t(e.prototype, n), r && t(e, r), e;
      };
    }(),
        d = {
      animatedValue: 0
    },
        y = function y() {},
        m = function (t) {
      function e() {
        var t, n, a, i;
        r(this, e);

        for (var u = arguments.length, c = Array(u), f = 0; f < u; f++) {
          c[f] = arguments[f];
        }

        return n = a = o(this, (t = e.__proto__ || Object.getPrototypeOf(e)).call.apply(t, [this].concat(c))), a.state = {
          animatedValue: 0
        }, a.componentDidMount = function () {
          a.animateValue();
        }, a.componentDidUpdate = function (t) {
          t.value !== a.props.value && a.animateValue();
        }, a.updateValue = function (t) {
          a.props.update(t);
          var e = d.animatedValue;
          a.setState({
            animatedValue: e
          });
        }, a.animateValue = function () {
          var t = a.props,
              e = t.duration,
              n = t.begin,
              r = t.easing,
              o = t.complete,
              i = t.run,
              u = t.delay,
              c = t.value;
          l()({
            targets: d,
            animatedValue: c,
            duration: e,
            update: a.updateValue,
            easing: r,
            begin: n,
            complete: o,
            run: i,
            delay: u
          });
        }, i = n, o(a, i);
      }

      return a(e, t), p(e, [{
        key: "render",
        value: function value() {
          return u.a.createElement("span", null, this.props.formatValue(Number(this.state.animatedValue)));
        }
      }]), e;
    }(i.Component);

    m.propTypes = {
      value: f.a.oneOfType([f.a.number, f.a.string]).isRequired,
      duration: f.a.number,
      delay: f.a.number,
      formatValue: f.a.func,
      begin: f.a.func,
      complete: f.a.func,
      run: f.a.func,
      update: f.a.func,
      easing: f.a.string
    }, m.defaultProps = {
      duration: 1e3,
      formatValue: function formatValue(t) {
        return t;
      },
      easing: "linear",
      run: y,
      complete: y,
      update: y,
      begin: y,
      delay: 0
    }, e.a = m;
  }, function (e, n) {
    e.exports = t;
  }, function (t, e, n) {
    t.exports = n(5)();
  }, function (t, e, n) {
    "use strict";

    var r = n(6),
        o = n(7),
        a = n(8);

    t.exports = function () {
      function t(t, e, n, r, i, u) {
        u !== a && o(!1, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
      }

      function e() {
        return t;
      }

      t.isRequired = t;
      var n = {
        array: t,
        bool: t,
        func: t,
        number: t,
        object: t,
        string: t,
        symbol: t,
        any: t,
        arrayOf: e,
        element: t,
        instanceOf: e,
        node: t,
        objectOf: e,
        oneOf: e,
        oneOfType: e,
        shape: e,
        exact: e
      };
      return n.checkPropTypes = r, n.PropTypes = n, n;
    };
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return function () {
        return t;
      };
    }

    var o = function o() {};

    o.thatReturns = r, o.thatReturnsFalse = r(!1), o.thatReturnsTrue = r(!0), o.thatReturnsNull = r(null), o.thatReturnsThis = function () {
      return this;
    }, o.thatReturnsArgument = function (t) {
      return t;
    }, t.exports = o;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r, a, i, u, c) {
      if (o(e), !t) {
        var f;
        if (void 0 === e) f = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
          var s = [n, r, a, i, u, c],
              l = 0;
          f = new Error(e.replace(/%s/g, function () {
            return s[l++];
          })), f.name = "Invariant Violation";
        }
        throw f.framesToPop = 1, f;
      }
    }

    var o = function o(t) {};

    t.exports = r;
  }, function (t, e, n) {
    "use strict";

    t.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (t, e, n) {
    (function (n) {
      var r,
          o,
          a,
          i = {
        scope: {}
      };
      i.defineProperty = "function" == typeof Object.defineProperties ? Object.defineProperty : function (t, e, n) {
        if (n.get || n.set) throw new TypeError("ES3 does not support getters and setters.");
        t != Array.prototype && t != Object.prototype && (t[e] = n.value);
      }, i.getGlobal = function (t) {
        return "undefined" != typeof window && window === t ? t : "undefined" != typeof n && null != n ? n : t;
      }, i.global = i.getGlobal(this), i.SYMBOL_PREFIX = "jscomp_symbol_", i.initSymbol = function () {
        i.initSymbol = function () {}, i.global.Symbol || (i.global.Symbol = i.Symbol);
      }, i.symbolCounter_ = 0, i.Symbol = function (t) {
        return i.SYMBOL_PREFIX + (t || "") + i.symbolCounter_++;
      }, i.initSymbolIterator = function () {
        i.initSymbol();
        var t = i.global.Symbol.iterator;
        t || (t = i.global.Symbol.iterator = i.global.Symbol("iterator")), "function" != typeof Array.prototype[t] && i.defineProperty(Array.prototype, t, {
          configurable: !0,
          writable: !0,
          value: function value() {
            return i.arrayIterator(this);
          }
        }), i.initSymbolIterator = function () {};
      }, i.arrayIterator = function (t) {
        var e = 0;
        return i.iteratorPrototype(function () {
          return e < t.length ? {
            done: !1,
            value: t[e++]
          } : {
            done: !0
          };
        });
      }, i.iteratorPrototype = function (t) {
        return i.initSymbolIterator(), t = {
          next: t
        }, t[i.global.Symbol.iterator] = function () {
          return this;
        }, t;
      }, i.array = i.array || {}, i.iteratorFromArray = function (t, e) {
        i.initSymbolIterator(), t instanceof String && (t += "");
        var n = 0,
            r = {
          next: function next() {
            if (n < t.length) {
              var o = n++;
              return {
                value: e(o, t[o]),
                done: !1
              };
            }

            return r.next = function () {
              return {
                done: !0,
                value: void 0
              };
            }, r.next();
          }
        };
        return r[Symbol.iterator] = function () {
          return r;
        }, r;
      }, i.polyfill = function (t, e, n, r) {
        if (e) {
          for (n = i.global, t = t.split("."), r = 0; r < t.length - 1; r++) {
            var o = t[r];
            o in n || (n[o] = {}), n = n[o];
          }

          t = t[t.length - 1], r = n[t], e = e(r), e != r && null != e && i.defineProperty(n, t, {
            configurable: !0,
            writable: !0,
            value: e
          });
        }
      }, i.polyfill("Array.prototype.keys", function (t) {
        return t || function () {
          return i.iteratorFromArray(this, function (t) {
            return t;
          });
        };
      }, "es6-impl", "es3");
      var u = this;
      !function (n, i) {
        o = [], r = i, void 0 !== (a = "function" === typeof r ? r.apply(e, o) : r) && (t.exports = a);
      }(0, function () {
        function t(t) {
          if (!N.col(t)) try {
            return document.querySelectorAll(t);
          } catch (t) {}
        }

        function e(t, e) {
          for (var n = t.length, r = 2 <= arguments.length ? arguments[1] : void 0, o = [], a = 0; a < n; a++) {
            if (a in t) {
              var i = t[a];
              e.call(r, i, a, t) && o.push(i);
            }
          }

          return o;
        }

        function n(t) {
          return t.reduce(function (t, e) {
            return t.concat(N.arr(e) ? n(e) : e);
          }, []);
        }

        function r(e) {
          return N.arr(e) ? e : (N.str(e) && (e = t(e) || e), e instanceof NodeList || e instanceof HTMLCollection ? [].slice.call(e) : [e]);
        }

        function o(t, e) {
          return t.some(function (t) {
            return t === e;
          });
        }

        function a(t) {
          var e,
              n = {};

          for (e in t) {
            n[e] = t[e];
          }

          return n;
        }

        function i(t, e) {
          var n,
              r = a(t);

          for (n in t) {
            r[n] = e.hasOwnProperty(n) ? e[n] : t[n];
          }

          return r;
        }

        function c(t, e) {
          var n,
              r = a(t);

          for (n in e) {
            r[n] = N.und(t[n]) ? e[n] : t[n];
          }

          return r;
        }

        function f(t) {
          t = t.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, function (t, e, n, r) {
            return e + e + n + n + r + r;
          });
          var e = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(t);
          t = parseInt(e[1], 16);
          var n = parseInt(e[2], 16),
              e = parseInt(e[3], 16);
          return "rgba(" + t + "," + n + "," + e + ",1)";
        }

        function s(t) {
          function e(t, e, n) {
            return 0 > n && (n += 1), 1 < n && --n, n < 1 / 6 ? t + 6 * (e - t) * n : .5 > n ? e : n < 2 / 3 ? t + (e - t) * (2 / 3 - n) * 6 : t;
          }

          var n = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(t) || /hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*([\d.]+)\)/g.exec(t);
          t = parseInt(n[1]) / 360;
          var r = parseInt(n[2]) / 100,
              o = parseInt(n[3]) / 100,
              n = n[4] || 1;
          if (0 == r) o = r = t = o;else {
            var a = .5 > o ? o * (1 + r) : o + r - o * r,
                i = 2 * o - a,
                o = e(i, a, t + 1 / 3),
                r = e(i, a, t);
            t = e(i, a, t - 1 / 3);
          }
          return "rgba(" + 255 * o + "," + 255 * r + "," + 255 * t + "," + n + ")";
        }

        function l(t) {
          if (t = /([\+\-]?[0-9#\.]+)(%|px|pt|em|rem|in|cm|mm|ex|ch|pc|vw|vh|vmin|vmax|deg|rad|turn)?$/.exec(t)) return t[2];
        }

        function p(t) {
          return -1 < t.indexOf("translate") || "perspective" === t ? "px" : -1 < t.indexOf("rotate") || -1 < t.indexOf("skew") ? "deg" : void 0;
        }

        function d(t, e) {
          return N.fnc(t) ? t(e.target, e.id, e.total) : t;
        }

        function y(t, e) {
          if (e in t.style) return getComputedStyle(t).getPropertyValue(e.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()) || "0";
        }

        function m(t, e) {
          return N.dom(t) && o(L, e) ? "transform" : N.dom(t) && (t.getAttribute(e) || N.svg(t) && t[e]) ? "attribute" : N.dom(t) && "transform" !== e && y(t, e) ? "css" : null != t[e] ? "object" : void 0;
        }

        function g(t, n) {
          var r = p(n),
              r = -1 < n.indexOf("scale") ? 1 : 0 + r;
          if (!(t = t.style.transform)) return r;

          for (var o = [], a = [], i = [], u = /(\w+)\((.+?)\)/g; o = u.exec(t);) {
            a.push(o[1]), i.push(o[2]);
          }

          return t = e(i, function (t, e) {
            return a[e] === n;
          }), t.length ? t[0] : r;
        }

        function h(t, e) {
          switch (m(t, e)) {
            case "transform":
              return g(t, e);

            case "css":
              return y(t, e);

            case "attribute":
              return t.getAttribute(e);
          }

          return t[e] || 0;
        }

        function v(t, e) {
          var n = /^(\*=|\+=|-=)/.exec(t);
          if (!n) return t;
          var r = l(t) || 0;

          switch (e = parseFloat(e), t = parseFloat(t.replace(n[0], "")), n[0][0]) {
            case "+":
              return e + t + r;

            case "-":
              return e - t + r;

            case "*":
              return e * t + r;
          }
        }

        function b(t, e) {
          return Math.sqrt(Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2));
        }

        function x(t) {
          t = t.points;

          for (var e, n = 0, r = 0; r < t.numberOfItems; r++) {
            var o = t.getItem(r);
            0 < r && (n += b(e, o)), e = o;
          }

          return n;
        }

        function w(t) {
          if (t.getTotalLength) return t.getTotalLength();

          switch (t.tagName.toLowerCase()) {
            case "circle":
              return 2 * Math.PI * t.getAttribute("r");

            case "rect":
              return 2 * t.getAttribute("width") + 2 * t.getAttribute("height");

            case "line":
              return b({
                x: t.getAttribute("x1"),
                y: t.getAttribute("y1")
              }, {
                x: t.getAttribute("x2"),
                y: t.getAttribute("y2")
              });

            case "polyline":
              return x(t);

            case "polygon":
              var e = t.points;
              return x(t) + b(e.getItem(e.numberOfItems - 1), e.getItem(0));
          }
        }

        function O(t, e) {
          function n(n) {
            return n = void 0 === n ? 0 : n, t.el.getPointAtLength(1 <= e + n ? e + n : 0);
          }

          var r = n(),
              o = n(-1),
              a = n(1);

          switch (t.property) {
            case "x":
              return r.x;

            case "y":
              return r.y;

            case "angle":
              return 180 * Math.atan2(a.y - o.y, a.x - o.x) / Math.PI;
          }
        }

        function P(t, e) {
          var n,
              r = /-?\d*\.?\d+/g;
          if (n = N.pth(t) ? t.totalLength : t, N.col(n)) {
            if (N.rgb(n)) {
              var o = /rgb\((\d+,\s*[\d]+,\s*[\d]+)\)/g.exec(n);
              n = o ? "rgba(" + o[1] + ",1)" : n;
            } else n = N.hex(n) ? f(n) : N.hsl(n) ? s(n) : void 0;
          } else o = (o = l(n)) ? n.substr(0, n.length - o.length) : n, n = e && !/\s/g.test(n) ? o + e : o;
          return n += "", {
            original: n,
            numbers: n.match(r) ? n.match(r).map(Number) : [0],
            strings: N.str(t) || e ? n.split(r) : []
          };
        }

        function S(t) {
          return t = t ? n(N.arr(t) ? t.map(r) : r(t)) : [], e(t, function (t, e, n) {
            return n.indexOf(t) === e;
          });
        }

        function j(t) {
          var e = S(t);
          return e.map(function (t, n) {
            return {
              target: t,
              id: n,
              total: e.length
            };
          });
        }

        function A(t, e) {
          var n = a(e);

          if (N.arr(t)) {
            var o = t.length;
            2 !== o || N.obj(t[0]) ? N.fnc(e.duration) || (n.duration = e.duration / o) : t = {
              value: t
            };
          }

          return r(t).map(function (t, n) {
            return n = n ? 0 : e.delay, t = N.obj(t) && !N.pth(t) ? t : {
              value: t
            }, N.und(t.delay) && (t.delay = n), t;
          }).map(function (t) {
            return c(t, n);
          });
        }

        function I(t, e) {
          var n,
              r = {};

          for (n in t) {
            var o = d(t[n], e);
            N.arr(o) && (o = o.map(function (t) {
              return d(t, e);
            }), 1 === o.length && (o = o[0])), r[n] = o;
          }

          return r.duration = parseFloat(r.duration), r.delay = parseFloat(r.delay), r;
        }

        function M(t) {
          return N.arr(t) ? q.apply(this, t) : Y[t];
        }

        function T(t, e) {
          var n;
          return t.tweens.map(function (r) {
            r = I(r, e);
            var o = r.value,
                a = h(e.target, t.name),
                i = n ? n.to.original : a,
                i = N.arr(o) ? o[0] : i,
                u = v(N.arr(o) ? o[1] : o, i),
                a = l(u) || l(i) || l(a);
            return r.from = P(i, a), r.to = P(u, a), r.start = n ? n.end : t.offset, r.end = r.start + r.delay + r.duration, r.easing = M(r.easing), r.elasticity = (1e3 - Math.min(Math.max(r.elasticity, 1), 999)) / 1e3, r.isPath = N.pth(o), r.isColor = N.col(r.from.original), r.isColor && (r.round = 1), n = r;
          });
        }

        function _(t, r) {
          return e(n(t.map(function (t) {
            return r.map(function (e) {
              var n = m(t.target, e.name);

              if (n) {
                var r = T(e, t);
                e = {
                  type: n,
                  property: e.name,
                  animatable: t,
                  tweens: r,
                  duration: r[r.length - 1].end,
                  delay: r[0].delay
                };
              } else e = void 0;

              return e;
            });
          })), function (t) {
            return !N.und(t);
          });
        }

        function k(t, e, n, r) {
          var o = "delay" === t;
          return e.length ? (o ? Math.min : Math.max).apply(Math, e.map(function (e) {
            return e[t];
          })) : o ? r.delay : n.offset + r.delay + r.duration;
        }

        function E(t) {
          var e,
              n = i(C, t),
              r = i(R, t),
              o = j(t.targets),
              a = [],
              u = c(n, r);

          for (e in t) {
            u.hasOwnProperty(e) || "targets" === e || a.push({
              name: e,
              offset: u.offset,
              tweens: A(t[e], r)
            });
          }

          return t = _(o, a), c(n, {
            children: [],
            animatables: o,
            animations: t,
            duration: k("duration", t, n, r),
            delay: k("delay", t, n, r)
          });
        }

        function V(t) {
          function n() {
            return window.Promise && new Promise(function (t) {
              return l = t;
            });
          }

          function r(t) {
            return d.reversed ? d.duration - t : t;
          }

          function o(t) {
            for (var n = 0, r = {}, o = d.animations, a = o.length; n < a;) {
              var i = o[n],
                  u = i.animatable,
                  c = i.tweens,
                  f = c.length - 1,
                  s = c[f];
              f && (s = e(c, function (e) {
                return t < e.end;
              })[0] || s);

              for (var c = Math.min(Math.max(t - s.start - s.delay, 0), s.duration) / s.duration, l = isNaN(c) ? 1 : s.easing(c, s.elasticity), c = s.to.strings, p = s.round, f = [], m = void 0, m = s.to.numbers.length, g = 0; g < m; g++) {
                var h = void 0,
                    h = s.to.numbers[g],
                    v = s.from.numbers[g],
                    h = s.isPath ? O(s.value, l * h) : v + l * (h - v);
                p && (s.isColor && 2 < g || (h = Math.round(h * p) / p)), f.push(h);
              }

              if (s = c.length) for (m = c[0], l = 0; l < s; l++) {
                p = c[l + 1], g = f[l], isNaN(g) || (m = p ? m + (g + p) : m + (g + " "));
              } else m = f[0];
              $[i.type](u.target, i.property, m, r, u.id), i.currentValue = m, n++;
            }

            if (n = Object.keys(r).length) for (o = 0; o < n; o++) {
              F || (F = y(document.body, "transform") ? "transform" : "-webkit-transform"), d.animatables[o].target.style[F] = r[o].join(" ");
            }
            d.currentTime = t, d.progress = t / d.duration * 100;
          }

          function a(t) {
            d[t] && d[t](d);
          }

          function i() {
            d.remaining && !0 !== d.remaining && d.remaining--;
          }

          function u(t) {
            var e = d.duration,
                u = d.offset,
                y = u + d.delay,
                m = d.currentTime,
                g = d.reversed,
                h = r(t);

            if (d.children.length) {
              var v = d.children,
                  b = v.length;
              if (h >= d.currentTime) for (var x = 0; x < b; x++) {
                v[x].seek(h);
              } else for (; b--;) {
                v[b].seek(h);
              }
            }

            (h >= y || !e) && (d.began || (d.began = !0, a("begin")), a("run")), h > u && h < e ? o(h) : (h <= u && 0 !== m && (o(0), g && i()), (h >= e && m !== e || !e) && (o(e), g || i())), a("update"), t >= e && (d.remaining ? (f = c, "alternate" === d.direction && (d.reversed = !d.reversed)) : (d.pause(), d.completed || (d.completed = !0, a("complete"), "Promise" in window && (l(), p = n()))), s = 0);
          }

          t = void 0 === t ? {} : t;
          var c,
              f,
              s = 0,
              l = null,
              p = n(),
              d = E(t);
          return d.reset = function () {
            var t = d.direction,
                e = d.loop;

            for (d.currentTime = 0, d.progress = 0, d.paused = !0, d.began = !1, d.completed = !1, d.reversed = "reverse" === t, d.remaining = "alternate" === t && 1 === e ? 2 : e, o(0), t = d.children.length; t--;) {
              d.children[t].reset();
            }
          }, d.tick = function (t) {
            c = t, f || (f = c), u((s + c - f) * V.speed);
          }, d.seek = function (t) {
            u(r(t));
          }, d.pause = function () {
            var t = X.indexOf(d);
            -1 < t && X.splice(t, 1), d.paused = !0;
          }, d.play = function () {
            d.paused && (d.paused = !1, f = 0, s = r(d.currentTime), X.push(d), D || B());
          }, d.reverse = function () {
            d.reversed = !d.reversed, f = 0, s = r(d.currentTime);
          }, d.restart = function () {
            d.pause(), d.reset(), d.play();
          }, d.finished = p, d.reset(), d.autoplay && d.play(), d;
        }

        var F,
            C = {
          update: void 0,
          begin: void 0,
          run: void 0,
          complete: void 0,
          loop: 1,
          direction: "normal",
          autoplay: !0,
          offset: 0
        },
            R = {
          duration: 1e3,
          delay: 0,
          easing: "easeOutElastic",
          elasticity: 500,
          round: 0
        },
            L = "translateX translateY translateZ rotate rotateX rotateY rotateZ scale scaleX scaleY scaleZ skewX skewY perspective".split(" "),
            N = {
          arr: function arr(t) {
            return Array.isArray(t);
          },
          obj: function obj(t) {
            return -1 < Object.prototype.toString.call(t).indexOf("Object");
          },
          pth: function pth(t) {
            return N.obj(t) && t.hasOwnProperty("totalLength");
          },
          svg: function svg(t) {
            return t instanceof SVGElement;
          },
          dom: function dom(t) {
            return t.nodeType || N.svg(t);
          },
          str: function str(t) {
            return "string" === typeof t;
          },
          fnc: function fnc(t) {
            return "function" === typeof t;
          },
          und: function und(t) {
            return "undefined" === typeof t;
          },
          hex: function hex(t) {
            return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(t);
          },
          rgb: function rgb(t) {
            return /^rgb/.test(t);
          },
          hsl: function hsl(t) {
            return /^hsl/.test(t);
          },
          col: function col(t) {
            return N.hex(t) || N.rgb(t) || N.hsl(t);
          }
        },
            q = function () {
          function t(t, e, n) {
            return (((1 - 3 * n + 3 * e) * t + (3 * n - 6 * e)) * t + 3 * e) * t;
          }

          return function (e, n, r, o) {
            if (0 <= e && 1 >= e && 0 <= r && 1 >= r) {
              var a = new Float32Array(11);
              if (e !== n || r !== o) for (var i = 0; 11 > i; ++i) {
                a[i] = t(.1 * i, e, r);
              }
              return function (i) {
                if (e === n && r === o) return i;
                if (0 === i) return 0;
                if (1 === i) return 1;

                for (var u = 0, c = 1; 10 !== c && a[c] <= i; ++c) {
                  u += .1;
                }

                --c;
                var c = u + (i - a[c]) / (a[c + 1] - a[c]) * .1,
                    f = 3 * (1 - 3 * r + 3 * e) * c * c + 2 * (3 * r - 6 * e) * c + 3 * e;

                if (.001 <= f) {
                  for (u = 0; 4 > u && 0 !== (f = 3 * (1 - 3 * r + 3 * e) * c * c + 2 * (3 * r - 6 * e) * c + 3 * e); ++u) {
                    var s = t(c, e, r) - i,
                        c = c - s / f;
                  }

                  i = c;
                } else if (0 === f) i = c;else {
                  var c = u,
                      u = u + .1,
                      l = 0;

                  do {
                    s = c + (u - c) / 2, f = t(s, e, r) - i, 0 < f ? u = s : c = s;
                  } while (1e-7 < Math.abs(f) && 10 > ++l);

                  i = s;
                }

                return t(i, n, o);
              };
            }
          };
        }(),
            Y = function () {
          function t(t, e) {
            return 0 === t || 1 === t ? t : -Math.pow(2, 10 * (t - 1)) * Math.sin(2 * (t - 1 - e / (2 * Math.PI) * Math.asin(1)) * Math.PI / e);
          }

          var e,
              n = "Quad Cubic Quart Quint Sine Expo Circ Back Elastic".split(" "),
              r = {
            In: [[.55, .085, .68, .53], [.55, .055, .675, .19], [.895, .03, .685, .22], [.755, .05, .855, .06], [.47, 0, .745, .715], [.95, .05, .795, .035], [.6, .04, .98, .335], [.6, -.28, .735, .045], t],
            Out: [[.25, .46, .45, .94], [.215, .61, .355, 1], [.165, .84, .44, 1], [.23, 1, .32, 1], [.39, .575, .565, 1], [.19, 1, .22, 1], [.075, .82, .165, 1], [.175, .885, .32, 1.275], function (e, n) {
              return 1 - t(1 - e, n);
            }],
            InOut: [[.455, .03, .515, .955], [.645, .045, .355, 1], [.77, 0, .175, 1], [.86, 0, .07, 1], [.445, .05, .55, .95], [1, 0, 0, 1], [.785, .135, .15, .86], [.68, -.55, .265, 1.55], function (e, n) {
              return .5 > e ? t(2 * e, n) / 2 : 1 - t(-2 * e + 2, n) / 2;
            }]
          },
              o = {
            linear: q(.25, .25, .75, .75)
          },
              a = {};

          for (e in r) {
            a.type = e, r[a.type].forEach(function (t) {
              return function (e, r) {
                o["ease" + t.type + n[r]] = N.fnc(e) ? e : q.apply(u, e);
              };
            }(a)), a = {
              type: a.type
            };
          }

          return o;
        }(),
            $ = {
          css: function css(t, e, n) {
            return t.style[e] = n;
          },
          attribute: function attribute(t, e, n) {
            return t.setAttribute(e, n);
          },
          object: function object(t, e, n) {
            return t[e] = n;
          },
          transform: function transform(t, e, n, r, o) {
            r[o] || (r[o] = []), r[o].push(e + "(" + n + ")");
          }
        },
            X = [],
            D = 0,
            B = function () {
          function t() {
            D = requestAnimationFrame(e);
          }

          function e(e) {
            var n = X.length;

            if (n) {
              for (var r = 0; r < n;) {
                X[r] && X[r].tick(e), r++;
              }

              t();
            } else cancelAnimationFrame(D), D = 0;
          }

          return t;
        }();

        return V.version = "2.2.0", V.speed = 1, V.running = X, V.remove = function (t) {
          t = S(t);

          for (var e = X.length; e--;) {
            for (var n = X[e], r = n.animations, a = r.length; a--;) {
              o(t, r[a].animatable.target) && (r.splice(a, 1), r.length || n.pause());
            }
          }
        }, V.getValue = h, V.path = function (e, n) {
          var r = N.str(e) ? t(e)[0] : e,
              o = n || 100;
          return function (t) {
            return {
              el: r,
              property: t,
              totalLength: w(r) * (o / 100)
            };
          };
        }, V.setDashoffset = function (t) {
          var e = w(t);
          return t.setAttribute("stroke-dasharray", e), e;
        }, V.bezier = q, V.easings = Y, V.timeline = function (t) {
          var e = V(t);
          return e.pause(), e.duration = 0, e.add = function (n) {
            return e.children.forEach(function (t) {
              t.began = !0, t.completed = !0;
            }), r(n).forEach(function (n) {
              var r = c(n, i(R, t || {}));
              r.targets = r.targets || t.targets, n = e.duration;
              var o = r.offset;
              r.autoplay = !1, r.direction = e.direction, r.offset = N.und(o) ? n : v(o, n), e.began = !0, e.completed = !0, e.seek(r.offset), r = V(r), r.began = !0, r.completed = !0, r.duration > n && (e.duration = r.duration), e.children.push(r);
            }), e.seek(0), e.reset(), e.autoplay && e.restart(), e;
          }, e;
        }, V.random = function (t, e) {
          return Math.floor(Math.random() * (e - t + 1)) + t;
        }, V;
      });
    }).call(e, n(10));
  }, function (t, e) {
    var n;

    n = function () {
      return this;
    }();

    try {
      n = n || Function("return this")() || (0, eval)("this");
    } catch (t) {
      "object" === typeof window && (n = window);
    }

    t.exports = n;
  }]);
});